const textEn = {
  // NAVBAR
  navbarHome: "Home",
  navbarSelectVehicle: "Choose Vehicle",
  navbarPriceList: "Price List",
  navbarHelp: "Help",
  navbarBlog: "Blog",
  navbarTransaction: "List Transaction",
  navbarOutcomeTransaction: 'List Outcome Transaction',
  navbarListVehicle: "List Vehicle",

  // HEADER
  welcomeHeaderPartOne: "Bali rent car starting from",
  welcomeHeaderPartTwo: "100",
  welcomeHeaderPartThree: "thousand only",
  bodyJargon: "Rent a vehicle anywhere and anytime easily",
  benefitHeaderOne: "Can be delivered anywhere",
  benefitHeaderTwo: "Free Cancellation",
  benefitHeaderThree: "100+ Cars and Motorcycles",
  benefitCaptionOne: "We can deliver the vehicle to your location. Free delivery fee for certain locations",
  benefitCaptionTwo: "Free cancellation of vehicle rental if you change your mind. No cancellation fee",
  benefitCaptionThree: "We have more than 100 vehicles that you can rent. Starting from cars to motorcycles",

  // HEADER FORM
  headerFormRentNow: "Book Now",
  headerFormPickUpLocation: "Pick Up Location",
  headerFormPickUpLocationPlaceholder: "Enter Location",
  headerFormPickUp: "Pick Up",
  hedaerFormPickUpPlaceHolder: "Select Date",
  hedaerFormPickUpTimePlaceHolder: "Select Time",
  headerFormDropOff: "Drop Off",
  headerFormDropOffPlaceHolder: "Select Date",
  headerFormDropOffTimePlaceHolder: "Select Time",
  headerFormContinueBooking: "Continue Booking",
  headerFormSubmit: "Submit",
  seePriceList: "Price List →",

  // CHECKOUT
  checkoutForm: "Checkout",
  checkoutVehicle: "Vehicle type rented",
  checkoutVehiclePlaceholder: "Select a vehicle",
  checkoutVoucher: "Voucher Code",
  checkoutVoucherPlaceholder: "Enter Voucher Code",
  checkoutTypeVehicle: "Type Vehicle",
  checkoutTypeMatic: "- Matic",
  checkoutTypeManual: "- Manual",
  checkoutTypeElectric: "- Electric",
  checkoutTermAndCondition: "I agree to the terms and conditions",
  checkoutReadTermAndCondition: "Read terms and conditions",
  checkoutPaymentDetail: "Payment Details",
  checkoutPaymentRentPrice: "Rent Price",
  checkoutPaymentDiscountVoucher: "Discount Voucher",
  checkoutPaymentAdminFee: "Admin Fee",
  checkoutPaymentTotal: "Total",
  checkoutName: "Full Name",
  checkoutNamePlaceholder: "Enter your full name",
  checkoutEmail: "Email",
  checkoutEmailPlaceholder: "Enter email",
  checkoutPhoneNumber: "Phone number",
  checkoutPhoneNumberPlaceholder: "Enter phone number",
  checkoutAddressBali: "Full address in Bali",
  checkoutAddressBaliPlaceholder: "Enter full address in Bali",
  checkoutCityKtp: "City as on ID card",
  checkoutCityKtpPlaceholder: "Enter city as on ID card",
  checkoutInstagram: "instagram",
  checkoutInstagramPlaceholder: "Enter Instagram account",
  checkoutStartRent: "Rental start date/time",
  checkoutEndRent: "Rental end date/time",
  checkoutPurpose: "Rental purpose",
  checkoutPurposePlaceholder: "Enter rental purpose",
  checkoutStatus: "Status (Choose 1)",
  checkoutStatusStudent: "Student",
  checkoutStatusTourist: "Tourist",
  checkoutStatusEmployee: "Employee",
  checkoutWebMaintenance: "Checkout via web is still under maintenance. Please order via WhatsApp.",
  checkoutRequired: "This field is required",
  checkoutPaymentMethod: "Payment Method",
  bri: "BRI",
  bca: "BCA",
  mandiri: "Mandiri",
  accountBankName: "a.n Kadek Dwi Bagus",
  or: "OR",

  // ORDER
  orderMyOrder: "My Order",
  orderNumber: "No. Order",
  orderStatus: "Status",
  orderTransferBefore: "Transfer Before",
  orderWaitingPayment: "Waiting Payment",
  orderPaymentSuccess: "Payment Success",
  orderName: "Name :",
  orderEmail: "Email :",
  orderPhoneNumber: "Phone Number :",
  orderVehicle: "Vehicle :",
  orderTypeVehicle: "Type :",
  orderPickUp: "Pick Up :",
  orderDropOff: "Drop Off :",
  orderLocation: "Location :",
  orderVoucher: "Voucher :",
  orderChangePaymentMethod: "Change Payment Method",
  orderChangeOrderDetail: "Change Order Detail",
  orderChangeVehicle: "Change Vehicle",

  // BODY LANDING
  bodyBestDeals: "Best Deals",

  // FOOTER
  greeting: 'Hello, {name}!',
  instagram: 'Instagram',
  tiktok: 'Tiktok',
  whatsapp: 'Whatsapp',
  aboutUs: 'About Us',
  contactUs: 'Contact Us',
  help: 'Help',
  location: 'Location',
  socialMedia: 'Social Media',
  company: 'Company',

  // ITEM
  itemOrderVehicle: "Order",
  itemStartFrom: "start from",

  // LIST ITEM 
  listItemVehicle: "Vehicle",
  listItemVehicleAll: "All Vehicle",
  listItemVehicleItem1: "Motorcycle",
  listItemVehicleItem2: "Car",
  listItemTypeVehicle: "Vehicle Type",
  listItemTypeVehicleAll: "All Type",
  listItemTypeVehicleItem1: "Matic",
  listItemTypeVehicleItem2: "Manual",
  listItemTypeVehicleItem3: "Electric",

  // PRICE LIST
  priceListVehicle: "Vehicle",
  priceListName: "Name",
  priceListTypeVehicle: "Type",
  priceListPrice: "Price",
  priceListPricePerDay: "Price/day",
  priceListPricePerMonth: "Price/month",
  priceListDetail: "Detail",

  // HELP
  helpNeedHelp: "Need Help?",
  helpNeedHelpCaption: "We are here to help you 24/7. If you have any questions, please contact us.",
  helpName: "Name",
  helpNamePlaceholder: "Enter Name",
  helpEmail: "Email",
  helpEmailPlaceholder: "Enter Email",
  helpPhoneNumber: "Phone Number (WhatsApp)",
  helpPhoneNumberPlaceholder: "Enter Phone Number",
  helpMessage: "Message",
  helpMessagePlaceholder: "Enter Message",
  helpSend: "Send",

  // util
  validateNik: "Validate NIK",
  updateDescription: "Update Description",
  "Unpaid Transaction": "Unpaid Transaction",

  // TNC
  tncTitle: "Term and Condition",
  tnc1: "The rental price of the vehicle is calculated on a daily basis (24 hours). Any usage exceeding this will incur an additional charge based on the daily rental rate.",
  tnc2: "Vehicle rental payment is to be made in advance, either through bank transfer or in cash before the rental commencement date.",
  tnc3: "An international driving license is required for foreigners.",
  tnc4: "A photo of the renter, along with the renter's identification card, will be taken for identification purposes.",
  tnc5: "Renters are not permitted to lend the vehicle to others to drive, and they are not allowed to take the vehicle outside of Bali without the consent of MY BALI RENT CAR.",
  tnc6: "The rental vehicle is not to be used for activities that violate the religious, societal, or legal norms in Indonesia.",
  tnc7: "Any DAMAGE or LOSS resulting from the renter's negligence shall be the renter's responsibility and shall be charged at the cost agreed upon with MY BALI RENT CAR.",
  tnc8: "The renter must follow MY BALI RENT CAR on social media (mybalirentcar) throughout the rental period",
  tnc9: "The renter must notify MY BALI RENT CAR if they change their place of residence. MOVING WITHOUT NOTIFICATION will incur a fine of Rp 2.000.000",

  // DUMMY TEXT
  dummyText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla vitae diam euismod, aliquam nisl ac, tincidunt sapien. Nul",
  dummyTnc: "1. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla vitae diam euismod, aliquam nisl."
};

export default textEn;
